export default "__VITE_ASSET__DmkRqZqr__"